import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ef953816&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ef953816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef953816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef953816')) {
      api.createRecord('ef953816', component.options)
    } else {
      api.reload('ef953816', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ef953816&scoped=true&", function () {
      api.rerender('ef953816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cBWHOjJlv8n0/JS/comp/CookieBox.vue"
export default component.exports